import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { MatSelectChange } from '@angular/material/select';
import { RenderedFormService } from '@app/shared/components/rendered-form/rendered-form.service';

export interface TestDataModalData {
  dynamicModels: any;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-test-data-modal',
  styleUrls: ['./test-data-modal.component.scss'],
  templateUrl: './test-data-modal.component.html'
})
export class TestDataModalComponent implements OnInit {
  close = (): void => this.dialogRef.close();
  selectedTemplate: any;
  dynamicModels: { [key: string]: any };

  BASE_KEYS = [
    'INVESTOR.LEGAL_NAME',
    'INVESTOR.TYPE',
    'INVESTOR.ENTITY_TYPE',
    'INVESTOR.ENTITY_SUBTYPE',
    'INVESTOR.TRUST_TYPE',
    'INVESTOR.TRUST_SUBTYPE',
    'INVESTOR.TAX_ID',
    'INVESTOR.TAX_ID_TYPE',
    'INVESTOR.DISREGARDED_ENTITY_LEGAL_NAME',
    'INVESTOR.DISREGARDED_ENTITY_TAX_ID',
    'INVESTOR.IS_US_PERSON',
    'ADDRESS.LINE_ONE',
    'ADDRESS.LINE_TWO',
    'ADDRESS.CITY',
    'ADDRESS.STATE',
    'ADDRESS.POSTAL',
    'ADDRESS.COUNTRY',
    'INVESTOR.IS_ACCREDITED_INVESTOR',
    'INVESTOR.IS_QUALIFIED_CLIENT',
    'INVESTOR.IS_QUALIFIED_PURCHASER',
    'INVESTOR.IS_FATCA',
    'INVESTOR.ERISA_DOL',
    'INVESTOR.BANK_NAME',
    'INVESTOR.BANK_ACCOUNT',
    'INVESTOR.BANK_ROUTING',
    'INVESTOR.BANK_WIRE_INSTRUCTIONS',
    'INVESTOR.BENEFICIARY_NAME'
  ];

  templates = [
    {
      data: {
        'ADDRESS.CITY': 'Somewhere',
        'ADDRESS.COUNTRY': 'US',
        'ADDRESS.LINE_ONE': '123 Somewhere St',
        'ADDRESS.POSTAL': '90210',
        'ADDRESS.STATE': 'ca',
        'INVESTOR.ENTITY_SUBTYPE': 's_corp',
        'INVESTOR.ENTITY_TYPE': 'limited_liability_company',
        'INVESTOR.IS_ACCREDITED_INVESTOR': true,
        'INVESTOR.IS_QUALIFIED_CLIENT': true,
        'INVESTOR.IS_QUALIFIED_PURCHASER': true,
        'INVESTOR.IS_US_PERSON': true,
        'INVESTOR.LEGAL_NAME': 'TestCorp, LLC',
        'INVESTOR.TAX_ID': '55-5555555',
        'INVESTOR.TAX_ID_TYPE': 'ein',
        'INVESTOR.TYPE': 'entity'
      },
      label: 'Entity - LLC S Corp (QP)'
    },
    {
      data: {
        'ADDRESS.CITY': 'Somewhere',
        'ADDRESS.COUNTRY': 'US',
        'ADDRESS.LINE_ONE': '123 Somewhere St',
        'ADDRESS.POSTAL': '90210',
        'ADDRESS.STATE': 'ca',
        'INVESTOR.ENTITY_TYPE': 'sole_proprietorship',
        'INVESTOR.IS_ACCREDITED_INVESTOR': true,
        'INVESTOR.IS_QUALIFIED_CLIENT': true,
        'INVESTOR.IS_QUALIFIED_PURCHASER': true,
        'INVESTOR.IS_US_PERSON': true,
        'INVESTOR.LEGAL_NAME': 'MichaelSoft',
        'INVESTOR.TAX_ID': '55-5555555',
        'INVESTOR.TAX_ID_TYPE': 'ein',
        'INVESTOR.TYPE': 'entity'
      },
      label: 'Entity - Sole Proprietorship (QP)'
    },
    {
      data: {
        'ADDRESS.CITY': 'Somewhere',
        'ADDRESS.COUNTRY': 'US',
        'ADDRESS.LINE_ONE': '123 Somewhere St',
        'ADDRESS.POSTAL': '90210',
        'ADDRESS.STATE': 'ca',
        'INVESTOR.IS_ACCREDITED_INVESTOR': true,
        'INVESTOR.IS_QUALIFIED_CLIENT': true,
        'INVESTOR.IS_QUALIFIED_PURCHASER': false,
        'INVESTOR.IS_US_PERSON': true,
        'INVESTOR.LEGAL_NAME': 'Ortiz Family Protection Trust',
        'INVESTOR.TRUST_SUBTYPE': 'family',
        'INVESTOR.TRUST_TYPE': 'irrevocable',
        'INVESTOR.TYPE': 'trust'
      },
      label: 'Trust - Irrevocable (QC)'
    },
    {
      data: {
        'ADDRESS.CITY': 'Somewhere',
        'ADDRESS.COUNTRY': 'US',
        'ADDRESS.LINE_ONE': '123 Somewhere St',
        'ADDRESS.POSTAL': '90210',
        'ADDRESS.STATE': 'ca',
        'INVESTOR.IS_ACCREDITED_INVESTOR': true,
        'INVESTOR.IS_QUALIFIED_CLIENT': false,
        'INVESTOR.IS_QUALIFIED_PURCHASER': false,
        'INVESTOR.IS_US_PERSON': true,
        'INVESTOR.LEGAL_NAME': 'Adrian Ortiz',
        'INVESTOR.TYPE': 'individual'
      },
      label: 'Individual (AI)'
    },
    {
      data: {
        'ADDRESS.CITY': 'Somewhere',
        'ADDRESS.COUNTRY': 'US',
        'ADDRESS.LINE_ONE': '123 Somewhere St',
        'ADDRESS.POSTAL': '90210',
        'ADDRESS.STATE': 'ca',
        'INVESTOR.IS_ACCREDITED_INVESTOR': true,
        'INVESTOR.IS_QUALIFIED_CLIENT': true,
        'INVESTOR.IS_QUALIFIED_PURCHASER': false,
        'INVESTOR.IS_US_PERSON': false,
        'INVESTOR.LEGAL_NAME': 'Michael Guidi',
        'INVESTOR.TYPE': 'individual'
      },
      label: 'Individual International (QC)'
    },
    {
      data: {
        'ADDRESS.CITY': 'Somewhere',
        'ADDRESS.COUNTRY': 'US',
        'ADDRESS.LINE_ONE': '123 Somewhere St',
        'ADDRESS.POSTAL': '90210',
        'ADDRESS.STATE': 'ca',
        'INVESTOR.IS_ACCREDITED_INVESTOR': true,
        'INVESTOR.IS_QUALIFIED_CLIENT': false,
        'INVESTOR.IS_QUALIFIED_PURCHASER': false,
        'INVESTOR.IS_US_PERSON': true,
        'INVESTOR.LEGAL_NAME': 'Mr. & Mrs. Smith',
        'INVESTOR.TYPE': 'joint'
      },
      label: 'Joint (AI)'
    }
  ];

  variableValueToAdd: any = {
    key: undefined,
    value: undefined
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TestDataModalData,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<TestDataModalData>,
    public renderedFormService: RenderedFormService
  ) {}

  ngOnInit(): void {
    this.dynamicModels = this.data.dynamicModels;
  }

  setTemplate(change: MatSelectChange): void {
    // Delete all base keys in case the newly selected template doesn't have the same keys
    for (let key of this.BASE_KEYS) {
      delete this.dynamicModels[key];
    }

    this.dynamicModels = {
      ...this.dynamicModels,
      ...change.value.data
    };
  }

  dynamicModelKeys(): string[] {
    return Object.keys(this.dynamicModels);
  }

  addNewVariableValue(): void {
    let variableValueToAdd = {};
    variableValueToAdd[this.variableValueToAdd.key] = this.variableValueToAdd.value;

    this.dynamicModels = {
      ...this.dynamicModels,
      ...variableValueToAdd
    };
    this.variableValueToAdd.key = this.variableValueToAdd.value = null;
  }

  removeVariableValue(key: string): void {
    delete this.dynamicModels[key];
  }

  applyDynamicModels(): void {
    this.renderedFormService.dynamicModels = this.dynamicModels;
    this.close();
  }
}
